module.exports = __webpack_public_path__ + "images/landing/video-previews/hubspot_preview_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/hubspot_preview_2x.jpg
// module id = 9PkT
// module chunks = 1